import { createSelector } from '@reduxjs/toolkit';

import { StoreState } from '../types';

import { FloorsState } from './types';

export const getFloorsState = (state: StoreState): FloorsState => state.floors;

export const getFloors = createSelector(
  getFloorsState,
  state => state.floorsById,
);
